import { UserManagementData, UserType } from './../models/user-management-data';
import { ToastService } from './../services/toast.service';
import { tap, catchError } from 'rxjs/operators';
import { ClientService } from './../services/client/client.service';
import { IAdaptorService } from './../shared/syncfusion/adaptor-service.interface';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { FilterDTO, PagedResultDTOOfUserInfoDTO, SortDirection, UserInfoDTO, FilterOperator, UserAccountClient, Role } from '../models/models.swagger.generated';
import { ShowInactiveService } from '../shared/grid-base/show-inactive.service';
import { SpinnerService } from '../spinner/spinner.service';

@Injectable({
  providedIn: 'root'
})
export class UserManagementService extends ShowInactiveService implements IAdaptorService {

  constructor(
    private userAccountClient: UserAccountClient,
    private clientService: ClientService,
    private toastService: ToastService,
    private spinnerService: SpinnerService
    ) {
      super();
    }


  public getData(skip: number, take: number, filters: FilterDTO[], sortBy: string | undefined, sortDirection: SortDirection | undefined): Observable<PagedResultDTOOfUserInfoDTO> {
    const selectedClient = this.clientService.selectedClient?.id;

    if (!this.showInactive) {
      if (!filters) {
        filters = [];
      }
      filters.push(new FilterDTO({isComplex: false, field: 'Enabled', operator: FilterOperator.Equal, value: 'true'}));
    }
    return this.userAccountClient.searchUsers(filters, selectedClient, skip, take, sortBy, sortDirection).pipe(
      tap((result: PagedResultDTOOfUserInfoDTO) => {
        if (result.items) {
          result.items.forEach((item: UserInfoDTO) => {
            if (!item.client) {
              item.client = {name: ''} as any;
            }
          })
        }
      })
    );
  }

  public updateRecord(data: UserManagementData): Observable<UserInfoDTO> {
    this.spinnerService.show();
    return this.userAccountClient.updateUser(data.data).pipe(
      tap(() => {
        this.spinnerService.hide();
        this.toastService.showSuccess(
          'i18n.core.messages.user-edit.success-title',
          'i18n.core.messages.user-edit.success-message');
      }),
      catchError(err => {
        this.spinnerService.hide();
        this.toastService.showApiException(err,
          'i18n.core.messages.user-edit.title',
          'i18n.core.messages.user-edit.message');
        return throwError(() => err);
      })
    );
  }

  public addRecord(data: UserManagementData): Observable<UserInfoDTO> {
    this.spinnerService.show();
    if (data.type === UserType.Mobile) {
      return this.userAccountClient.addMobileUser(data.data).pipe(
        tap(() => {
          this.spinnerService.hide();
          this.toastService.showSuccess(
            'i18n.core.messages.user-add.success-title',
            'i18n.core.messages.user-add.success-message');
        }),
        catchError(err => {
          this.spinnerService.hide();
          this.toastService.showApiException(err,
            'i18n.core.messages.user-add.title',
            'i18n.core.messages.user-add.message');
          return throwError(() => err);
        })
      );
    }
    return this.userAccountClient.addUser(data.data).pipe(
      tap(() => {
        this.spinnerService.hide();
        this.toastService.showSuccess(
          'i18n.core.messages.user-add.success-title',
          'i18n.core.messages.user-add.success-message');
      }),
      catchError(err => {
        this.spinnerService.hide();
        this.toastService.showApiException(err,
          'i18n.core.messages.user-add.title',
          'i18n.core.messages.user-add.message');
        return throwError(() => err);
      })
    );
  }

  public deleteRecord(id: number): Observable<any> {
    throw new Error('Method not implemented.');
  }
}
